<script lang="ts">
  import { Check, AlertTriangle, Info, X, AlertCircle } from "lucide-svelte";
  import { toasts, dismiss, type ToastKind } from "./toast";
  import { cn } from "./lib/utils";

  function iconFor(kind: ToastKind) {
    if (kind === "success") return Check;
    if (kind === "warn") return AlertTriangle;
    if (kind === "error") return AlertCircle;
    return Info;
  }

  function styleFor(kind: ToastKind) {
    if (kind === "success") return "border-success/60 text-success bg-card";
    if (kind === "warn") return "border-warn/60 text-warn bg-card";
    if (kind === "error") return "border-destructive/60 text-destructive bg-card";
    return "border-primary/40 text-foreground bg-card";
  }
</script>

<div class="pointer-events-none fixed inset-x-0 top-6 z-50 flex flex-col items-center gap-2 px-4">
  {#each $toasts as t (t.id)}
    {@const Icon = iconFor(t.kind)}
    <div
      class={cn(
        "anim-toast-in pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border bg-card px-4 py-3 shadow-lg",
        styleFor(t.kind)
      )}
    >
      <Icon class="mt-0.5 size-4 shrink-0" />
      <div class="min-w-0 flex-1">
        <p class="text-sm font-medium text-foreground">{t.message}</p>
        {#if t.description}
          <p class="mt-0.5 text-xs text-muted-foreground">{t.description}</p>
        {/if}
      </div>
      {#if t.action}
        <button
          type="button"
          class="focus-amber shrink-0 rounded-md bg-primary/10 px-2.5 py-1 text-[11px] font-semibold text-primary hover:bg-primary/20"
          on:click={() => {
            t.action?.run();
            dismiss(t.id);
          }}
        >
          {t.action.label}
        </button>
      {/if}
      <button
        type="button"
        class="shrink-0 rounded-md p-1 text-muted-foreground hover:bg-foreground/5 hover:text-foreground"
        aria-label="关闭"
        on:click={() => dismiss(t.id)}
      >
        <X class="size-3.5" />
      </button>
    </div>
  {/each}
</div>
